module.exports = __webpack_public_path__ + "image@3x.png?fcded678134591a4549b6c6fe1cf5048";